/**
 * Cover constructor
 * @constructor app.editor.stage.Cover
 */
fx.ns("shared.stage", class CalendarCover extends shared.stage.CalendarArea {

	constructor(cover, model, parentContainer, side) {
		super(cover, model, parentContainer, side);
	}

	/***************** Getters / Setters *****************/

	get cover() {
		return this.data;
	}

    get pageHeight() {
        return this.realHeight;
    }

	/***************** Actions *****************/


	updateChildPositions() 
    {
		super.updateChildPositions();		
	}

    updateSidePositions() 
    {
        if (!this.initialized || !this.page) return;

        this.height(this.calendar.pageHeight);// +1 allows to fix probleme on mobile that shows black on top of cover

        if (!this.calendar.isSinglePage && fx.browser.isMobile)
            this.width( this.pageWidth + 1);
        

        if (this.container) {
            this.container.left(0);
            this.container.height(this.areaHeight);
        }

        if (this.backgroundTop) {
            this.backgroundTop.show();
            this.backgroundTop.left(0);
            
        }

        if (this.backgroundBottom) {
            this.backgroundBottom.show();
            this.backgroundBottom.left(0);
            
        }

		if (this.displayedSide)
			this.addClass(this.displayedSide);

        this.stageContainer.height(this.calendar.pageHeight);
        this.stageContainer.top(this.calendar.pageHeight);

        this.stage.height(this.areaHeight);
        this.stage.top( - this.calendar.pageHeight );

        this.backgroundTop.top(0);
        this.backgroundBottom.top(this.calendar.pageHeight);

        if (this.binding)
            this.binding.top(this.calendar.pageHeight);
    }


});